import React from 'react';
import MaterialTable, { Query, QueryResult } from 'material-table';
import { CertificationModel } from '../../models/certificationModel';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { CertificateTypesOfficial } from '../../models/eums/certification/certificateTypesOfficial';
import { TextField } from '@material-ui/core';
import moment from 'moment';
import { DatePicker } from '../datePicker';
import { AddItemToolbar } from '../addItemDataTableToolbar/addItemToolbar';
import { useTranslation } from 'react-i18next';
import { localization } from '../../config/localization';

interface Props {
  onRowAdd: (newCert: CertificationModel) => Promise<any>;
  onRowUpdate: (newCert: CertificationModel, oldCert?: CertificationModel) => Promise<any>;
  onRowDelete: (oldData: CertificationModel) => Promise<any>;
  data:
    | CertificationModel[]
    | ((query: Query<CertificationModel>) => Promise<QueryResult<CertificationModel>>);
}

export function PersonCertificationTable(props: Props) {
  const { onRowAdd, onRowUpdate, onRowDelete, data } = props;
  const { t } = useTranslation();

  return (
    <MaterialTable<CertificationModel>
      options={{
        pageSize: 10,
        showTitle: false,
        search: false,
        headerStyle: {
          fontWeight: 'bold',
          backgroundColor: '#F5F5F5',
        },
      }}
      editable={{
        onRowAdd,
        onRowUpdate,
        onRowDelete,
      }}
      localization={localization()}
      columns={[
        {
          title: t('type'),
          field: 'type',
          editComponent: props => (
            <Autocomplete
              options={Object.values(CertificateTypesOfficial)}
              style={{ width: 300 }}
              onChange={(ev: object, val: any) => props.onChange(val)}
              value={props.value || null}
              renderInput={(params: any) => (
                <TextField style={{ width: '100%' }} {...params} variant='standard' />
              )}
            />
          ),
        },
        {
          title: t('issued-date'),
          field: 'certValidity.from',
          render: val =>
            val.certValidity?.from && moment(val.certValidity.from).format('DD.MM.YYYY'),
          editComponent: props => (
            <DatePicker
              onChange={props.onChange}
              format='dd.MM.yyyy.'
              value={props.value || null}
              variant='inline'
            />
          ),
        },
        {
          title: t('expiry-date'),
          field: 'certValidity.to',
          render: val => val.certValidity?.to && moment(val.certValidity.to).format('DD.MM.YYYY'),
          editComponent: props => (
            <DatePicker
              onChange={props.onChange}
              format='dd.MM.yyyy.'
              value={props.value || null}
              variant='inline'
            />
          ),
        },
      ]}
      data={data}
      components={{
        Toolbar: props => <AddItemToolbar {...props} />,
      }}
    />
  );
}
